<template>
  <div class="date-range">
    <div class="add-row">
      <div class="text-container">
        <div class="sub-title">
          <span>{{ startTime }}</span>
          <span v-if="required" class="star">*</span>
        </div>
        <div class="phone-content">
          <span>{{ placeholder }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="text-container">
        <div class="sub-title">
          <span>{{ endTime }}</span>
          <span v-if="required" class="star">*</span>
        </div>
        <div class="phone-content">
          <span>{{ placeholder }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="text-container">
      <div class="sub-title">
        <span>{{ durationTime }}</span>
      </div>
      <div class="phone-content">
        <span>自动计算</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /* 是否必填 */
    required: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    /* 开始日期 */
    startTime: {
      type: String,
      default: '开始日期'
    },
    /* 结束日期 */
    endTime: {
      type: String,
      default: '结束日期'
    },
    /* 时长（天） */
    durationTime: {
      type: String,
      default: '时长（天）'
    }
  },

  data() {
    return {
    }
  },

  created() {},

  methods: {
  }
}
</script>

<style lang='scss' scoped>
.phone-content {
  height: 20px;
}
</style>
